// Carrier logo URLs - using official logos where available
// Falls back to placeholder for unknown carriers

const CARRIER_LOGOS = {
    // Major US Carriers
    usps: "https://www.usps.com/assets/images/home/usps-logo.svg",
    ups: "https://www.ups.com/assets/resources/webcontent/images/ups-logo.svg",
    fedex: "https://www.fedex.com/content/dam/fedex-com/logos/logo.png",
    dhl_express: "https://www.dhl.com/content/dam/dhl/global/core/images/logos/dhl-logo.svg",
    dhl_ecommerce: "https://www.dhl.com/content/dam/dhl/global/core/images/logos/dhl-logo.svg",
    dhl_germany: "https://www.dhl.com/content/dam/dhl/global/core/images/logos/dhl-logo.svg",
    dhl_benelux: "https://www.dhl.com/content/dam/dhl/global/core/images/logos/dhl-logo.svg",
    
    // Regional US Carriers
    ontrac: "https://www.ontrac.com/images/ontrac-logo.svg",
    lasership: "https://images.ctfassets.net/p4igh2bxlcya/6YZp0fzNJKoY2YMKmGO2y/b7f54f8a72c85f6e6ba7f2dd3b8d3f3e/LaserShip_Logo.png",
    gso: "https://www.gso.com/wp-content/uploads/2020/08/gso-logo.png",
    lso: "https://www.lso.com/wp-content/uploads/2021/04/lso-logo.svg",
    
    // International Carriers
    canada_post: "https://www.canadapost-postescanada.ca/cpc/assets/cpc/images/logos/canada-post-logo.svg",
    australia_post: "https://auspost.com.au/content/dam/auspost_corp/media/images/logos/auspost-logo.svg",
    royal_mail: "https://www.royalmail.com/themes/custom/royal_mail/logo.svg",
    royal_mail_sf: "https://www.royalmail.com/themes/custom/royal_mail/logo.svg",
    deutsche_post: "https://www.deutschepost.de/content/dam/dpag/images/logos/dp-logo.svg",
    la_poste: "https://www.laposte.fr/etc/designs/lp/img/logo-laposte.svg",
    purolator: "https://www.purolator.com/sites/all/themes/purolator/logo.svg",
    
    // European Carriers
    dpd_de: "https://www.dpd.com/de/wp-content/uploads/sites/77/2019/10/dpd-logo.svg",
    dpd_uk: "https://www.dpd.com/de/wp-content/uploads/sites/77/2019/10/dpd-logo.svg",
    hermes_uk: "https://www.evri.com/assets/images/evri-logo.svg",
    chronopost: "https://www.chronopost.fr/sites/all/themes/chronopost/images/logo.svg",
    colissimo: "https://www.colissimo.fr/sites/all/themes/colissimo/logo.svg",
    gls_us: "https://gls-group.eu/GROUP/media/gls-logo.svg",
    bring: "https://www.bring.no/radgivning/bring-logo.svg",
    posti: "https://www.posti.fi/sites/posti.fi/files/posti-logo.svg",
    
    // Asian Carriers
    nippon_express: "https://www.nipponexpress.com/common/img/logo.svg",
    aramex: "https://www.aramex.com/Sitefinity/WebsiteTemplates/aramex/App_Themes/aramex/Images/aramex-logo.svg",
    
    // Latin American Carriers
    correios_br: "https://www.correios.com.br/resources/img/logo_correios.svg",
    correos_espana: "https://www.correos.es/ss/Satellite/site/estaticos-1363266518447-imagenes/correos-logo.svg",
    estafeta: "https://www.estafeta.com/images/logo.svg",
    
    // Other Carriers
    asendia_us: "https://www.asendia.com/themes/custom/asendia/logo.svg",
    sendle: "https://www.sendle.com/assets/images/sendle-logo.svg",
    axlehire: "https://www.jitsu.com/images/logo.svg",
    veho: "https://www.shipveho.com/assets/images/veho-logo.svg",
    better_trucks: "https://bettertrucks.com/wp-content/uploads/2022/01/bt-logo.svg",
    pitney_bowes: "https://www.pitneybowes.com/content/dam/pitneybowes/global/en-US/images/logos/pb-logo.svg",
    
    // Test carrier
    shippo: "https://goshippo.com/wp-content/uploads/2023/03/shippo-logo.svg",
};

// Simple text-based fallback logos using carrier initials
const CARRIER_COLORS = {
    usps: "#004B87",
    ups: "#351C15",
    fedex: "#4D148C",
    dhl_express: "#FFCC00",
    dhl_ecommerce: "#FFCC00",
    dhl_germany: "#FFCC00",
    dhl_benelux: "#FFCC00",
    canada_post: "#E31837",
    australia_post: "#DC1928",
    royal_mail: "#E30613",
    royal_mail_sf: "#E30613",
    deutsche_post: "#FFCC00",
    dpd_de: "#DC0032",
    dpd_uk: "#DC0032",
    ontrac: "#00A4E4",
    lasership: "#FF6B00",
    aramex: "#E31E24",
    purolator: "#E31837",
    shippo: "#3D7EFF",
};

export const getCarrierLogo = (carrierToken) => {
    return CARRIER_LOGOS[carrierToken] || null;
};

export const getCarrierColor = (carrierToken) => {
    return CARRIER_COLORS[carrierToken] || "#6B7280";
};

export const getCarrierInitials = (carrierName) => {
    if (!carrierName) return "??";
    const words = carrierName.split(/[\s_-]+/);
    if (words.length >= 2) {
        return (words[0][0] + words[1][0]).toUpperCase();
    }
    return carrierName.substring(0, 2).toUpperCase();
};
